/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Venues_Select_HintInputs */

const cs_settings_venues_select_hint = /** @type {(inputs: Settings_Venues_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlevo vyberte pobočku, uvidíte lidi a firmu.`)
};

const en_settings_venues_select_hint = /** @type {(inputs: Settings_Venues_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a venue on the left to see people and company.`)
};

/**
* | output |
* | --- |
* | "Pick a venue on the left to see people and company." |
*
* @param {Settings_Venues_Select_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_venues_select_hint = /** @type {((inputs?: Settings_Venues_Select_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Venues_Select_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_venues_select_hint(inputs)
	return cs_settings_venues_select_hint(inputs)
});